import React, { FC, useContext } from 'react';
import { ProductContext } from './../../contexts';
import ExcludedBrandsDialog from '../ExcludedBrandsDialog';
export interface BrandsProps {
  widgetData: any;
}

const ExcludedBrandsNote: FC<BrandsProps> = ({ widgetData }) => {
  const { initialColor } = useContext(ProductContext);
  const contactCenterNotesRaw = initialColor?.masterVariant?.attributesRaw.find(
    (attr: { name: string }) => attr.name === 'contactCenterNotes',
  )?.value;

  let contactCenterNotes: any[] = [];

  if (typeof contactCenterNotesRaw === 'string' && contactCenterNotesRaw?.trim()?.length > 0) {
    try {
      contactCenterNotes = JSON.parse(contactCenterNotesRaw);
    } catch (err) {
      console.error('Unable to parse contactCenterNotes:', err, contactCenterNotesRaw);
    }
  }

  const formatDate = (date: string): string => {
    if (!date) return '';
    const [year, month, day] = date?.split('-');
    const mm = month?.padStart(2, '0');
    const dd = day?.padStart(2, '0');
    return `${mm}/${dd}/${year}`;
  };

  const formattedNotes = contactCenterNotes?.filter((n) => n?.value && (n?.end_date || n?.endDate)) ?? [];

  const promotionsAllowed = initialColor?.masterVariant?.attributesRaw.find(
    (attr: { name: string }) => attr.name === 'promotionsAllowed',
  )?.value;

  return (
    <section className="mt-5 rounded-lg border border-[#B6B6B8] px-4 py-5">
      <section className="mb-3 whitespace-pre-line text-sm">
        <section className="mb-1 font-bold">Notes:</section>
        {formattedNotes?.map((note: any, index: number) => (
          <p className="mb-2" key={index}>
            {(note?.end_date || note?.endDate) && (
              <span className="mr-2">{note?.endDate ? formatDate(note?.endDate) : formatDate(note?.end_date)} -</span>
            )}
            <span
              dangerouslySetInnerHTML={{
                __html: note?.value,
              }}
            />
          </p>
        ))}
      </section>

      {promotionsAllowed ? (
        <p className="mb-3 text-sm">
          <strong>Promotion Eligible</strong>
        </p>
      ) : (
        <section className="flex items-center">
          <p className="mr-2 text-sm">
            <strong>Not Promotion Eligible:</strong>
          </p>
          <ExcludedBrandsDialog widgetData={widgetData} />
        </section>
      )}
    </section>
  );
};

export default ExcludedBrandsNote;
